
import { defineComponent, computed } from "vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  name: "RecipeImageView",
  props: {
    /**
     * 画像
     */
    imageUrl: {
      type: String
    }
  },
  setup(props) {
    NativeClient.sendDebugLog(
      "RecipeImageView getHeight window width=" + window.innerWidth + " height=" + (window.innerWidth * 0.75)
    );
    const styleImage = computed(() => {
      const imageWidth = window.innerWidth;
      const imageHeight = Math.round(imageWidth * 3 / 4);
      NativeClient.sendDebugLog("DetailInstructionItem styleImage imageWidth=" + imageWidth + " imageHeight=" + imageHeight);
      return { height: imageHeight + `px`, width: imageWidth + `px` };
    });
    return {
      styleImage
    };
  }
});
